import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import authRepository from '@/services/AuthRepository'

const todayKey = () => {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

const store = createStore({
  state: {
    token: '',
    permission: '',

    // popup mỗi ngày
    dailyPopupDate: '',

    // 🔔 notification badge
    notificationCount: 0
  },

  getters: {
    isLoggedIn (state): boolean {
      return !!state.token
    },

    shouldShowDailyPopup (state): boolean {
      return state.dailyPopupDate !== todayKey()
    },

    // 🔔 badge getter
    notificationCount (state): number {
      return state.notificationCount
    }
  },

  mutations: {
    /* ===== AUTH ===== */
    setToken (state, token: string) {
      state.token = token
    },
    clearToken (state) {
      state.token = ''
    },

    setPermission (state, permission: string) {
      state.permission = permission
    },
    clearPermission (state) {
      state.permission = ''
    },

    /* ===== POPUP ===== */
    markDailyPopupShown (state) {
      state.dailyPopupDate = todayKey()
    },
    cleanDailyPopupShown (state) {
      state.dailyPopupDate = ''
    },

    /* ===== 🔔 NOTIFICATION ===== */
    setNotificationCount (state, count: number) {
      state.notificationCount = count
    },
    clearNotificationCount (state) {
      state.notificationCount = 0
    }
  },

  actions: {
    /* ===== AUTH ===== */
    setToken ({ commit }, token: string) {
      commit('setToken', token)
    },
    clearToken ({ commit }) {
      commit('clearToken')
      commit('clearNotificationCount')
    },

    setPermission ({ commit }, permission: string) {
      commit('setPermission', permission)
    },
    clearPermission ({ commit }) {
      commit('clearPermission')
    },

    /* ===== POPUP ===== */
    markDailyPopupShown ({ commit }) {
      commit('markDailyPopupShown')
    },
    cleanDailyPopupShown ({ commit }) {
      commit('cleanDailyPopupShown')
    },

    /* ===== 🔔 FETCH NOTIFICATION ===== */
    async fetchNotification ({ commit, state }) {
      try {
        // ⛔ không gọi API khi chưa login
        if (!state.token) {
          commit('clearNotificationCount')
          return
        }

        const res = await authRepository.getNotification()

        const count = res?.data?.count ?? 0
        commit('setNotificationCount', count)
      } catch (err) {
        console.error('fetchNotification error:', err)
        commit('clearNotificationCount')
      }
    }
  },

  plugins: [
    createPersistedState({
      paths: [
        'token',
        'permission',
        'dailyPopupDate'
        // ❌ KHÔNG persist notificationCount (tránh badge cũ)
      ]
    })
  ]
})

export default store
